namespace TabAurous.CRM {
    export interface ProductCatalogForm {
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ItemTypeId: Serenity.IntegerEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        AttributeId: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsNew: Serenity.BooleanEditor;
        IsFeatured: Serenity.BooleanEditor;
        IsConfigurable: Serenity.BooleanEditor;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        Purity: Serenity.DecimalEditor;
        IsDefaultSKU: Serenity.BooleanEditor;
        ForExchange: Serenity.BooleanEditor;
        SKU: Serenity.StringEditor;
        Parts: Serenity.IntegerEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
        BOMDetails: OMS.ProductBOMEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Variance: Serenity.DecimalEditor;
        PointerWeight: Serenity.DecimalEditor;
        Rate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        PriceMarkup: Serenity.DecimalEditor;
        LaborMarkup: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: Serenity.DecimalEditor;
        Remarks: Serenity.StringEditor;
        LaborDetails: OMS.ProductMasterLaborEditor;
        InspectionDetails: OMS.ProductInspectionEditor;
        SequenceDetails: OMS.ProductSequenceEditor;
        MoldsDetails: OMS.ProductMoldsEditor;
        Image4: Serenity.ImageUploadEditor;
        Image5: Serenity.ImageUploadEditor;
        Image6: Serenity.ImageUploadEditor;
        Image7: Serenity.ImageUploadEditor;
        Image8: Serenity.ImageUploadEditor;
        Video1: Serenity.ImageUploadEditor;
        Video2: Serenity.ImageUploadEditor;
    }

    export class ProductCatalogForm extends Serenity.PrefixedContext {
        static formKey = 'CRM.ProductCatalog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductCatalogForm.init)  {
                ProductCatalogForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.BooleanEditor;
                var w6 = CommonProductSizeLookup;
                var w7 = s.DecimalEditor;
                var w8 = s.ImageUploadEditor;
                var w9 = OMS.ProductBOMEditor;
                var w10 = OMS.ProductMasterLaborEditor;
                var w11 = OMS.ProductInspectionEditor;
                var w12 = OMS.ProductSequenceEditor;
                var w13 = OMS.ProductMoldsEditor;

                Q.initFormType(ProductCatalogForm, [
                    'ProductId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'ProductTypeId', w1,
                    'ItemTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w1,
                    'CollectionId', w1,
                    'SuperTypeId', w1,
                    'AttributeId', w0,
                    'CalcOnId', w1,
                    'CalcUnitId', w1,
                    'HSN', w1,
                    'TaxCode', w1,
                    'IsDisabled', w5,
                    'IsNew', w5,
                    'IsFeatured', w5,
                    'IsConfigurable', w5,
                    'HasBom', w5,
                    'MetalId', w1,
                    'KaratId', w1,
                    'MetalColorId', w1,
                    'ProductSizeId', w6,
                    'Purity', w7,
                    'IsDefaultSKU', w5,
                    'ForExchange', w5,
                    'SKU', w0,
                    'Parts', w2,
                    'ImageName', w8,
                    'Image1', w8,
                    'Image2', w8,
                    'Image3', w8,
                    'BOMDetails', w9,
                    'Pieces', w2,
                    'Weight', w7,
                    'NetWeight', w7,
                    'Variance', w7,
                    'PointerWeight', w7,
                    'Rate', w7,
                    'UnitLabour', w7,
                    'PriceMarkup', w7,
                    'LaborMarkup', w7,
                    'DiamondPieces', w2,
                    'DiamondWeight', w7,
                    'StonePieces', w2,
                    'StoneWeight', w7,
                    'OtherPieces', w2,
                    'OtherWeight', w7,
                    'Remarks', w0,
                    'LaborDetails', w10,
                    'InspectionDetails', w11,
                    'SequenceDetails', w12,
                    'MoldsDetails', w13,
                    'Image4', w8,
                    'Image5', w8,
                    'Image6', w8,
                    'Image7', w8,
                    'Image8', w8,
                    'Video1', w8,
                    'Video2', w8
                ]);
            }
        }
    }
}
